module.exports = __webpack_public_path__ + "static/media/4.06629cee.svg";